import { Component, Output, EventEmitter, ChangeDetectionStrategy, forwardRef, Input, ChangeDetectorRef, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'app-optimization-preferences-btn-group',
    templateUrl: './optimization-preferences-btn-group.component.html',
    styleUrls: ['./optimization-preferences-btn-group.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OptimizationPreferencesBtnGroupComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OptimizationPreferencesBtnGroupComponent implements ControlValueAccessor {
    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    public get value() {
        return this._value;
    }

    @Input()
    public set value(value: number) {
        this._value = value;
        this._onChange(value);
        this._onTouched(value);
    }

    @Input() public disableLowPriority: boolean;
    @Input() public disableHighPriority: boolean;
    @Input() public disableCriticalPriority: boolean;

    @Output() public change = new EventEmitter<void>();

    private _value: number;

    public select(button: number): void {
        this.value = this.value === button ? 0 : button;
        this.change.emit();
    }

    registerOnChange(fn: any): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this._onTouched = fn;
    }

    writeValue(value: number): void {
        if (value !== null) {
            this.value = value;
            this.changeDetectorRef.markForCheck();
        }
    }

    public onChange(value: any): void {
        setTimeout(() => {
            this.change.emit(value);
        });
    }

    private _onChange: any = () => {};
    private _onTouched: any = () => {};
}
